import { all } from 'redux-saga/effects';

import authSaga from './auth/saga';
import layoutSaga from './layout/saga';
import businessSaga from './business/saga';
import menuManagementCategorySaga from './menuManagementCategory/saga';
import menuManagementItemSaga from './menuManagementItem/saga';
import recipeIngredientManagementSaga from './recipeIngredientsManagement/saga';
import recipeManagementSaga from './recipeManagement/saga';
import contactSaga from './contactUs/saga';
// import contactSaga from './contactUs/saga';
import SubAndPlansSaga from './subscriptionsAndPlans/saga';
import moduleSaga from './module/saga';
import settingsSaga from './settings/saga';
import dashboardOutletsSaga from './dashboard/saga';
import variantSaga from './variants/saga';

export default function* rootSaga() {
    yield all([
        authSaga(),
        layoutSaga(),
        businessSaga(),
        menuManagementCategorySaga(),
        menuManagementItemSaga(),
        recipeManagementSaga(),
        recipeIngredientManagementSaga(),
        contactSaga(),
        // contactSaga(),
        SubAndPlansSaga(),
        moduleSaga(),
        settingsSaga(),
        dashboardOutletsSaga(),
        variantSaga(),
    ]);
}
